module.exports = __webpack_public_path__ + "img/ico-vr-logo.5eb24414.png";